import React from 'react';
import { useInView } from 'react-intersection-observer';

function SectionReveal({ children, className = '', animation = 'fadeInUp', delay = 0, threshold = 0.15 }) {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce: true,
  });

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView
          ? 'translateY(0) translateX(0) scale(1)'
          : animation === 'fadeInUp'
          ? 'translateY(40px)'
          : animation === 'slideInLeft'
          ? 'translateX(-60px)'
          : animation === 'slideInRight'
          ? 'translateX(60px)'
          : animation === 'scaleIn'
          ? 'scale(0.85)'
          : 'translateY(40px)',
        transition: `all 0.7s cubic-bezier(0.25, 0.8, 0.25, 1) ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default SectionReveal;
